import download from "downloadjs";
import { action, computed } from "mobx";
import Month from "entities/month";
import type ReportRepository from "repositories/reportRepository";
import type LocalizationService from "services/localizationService";
import type MonthOptionsService from "services/monthOptionsService";
import { watchBusy } from "utils/busyWatcher";
import parseFileNameFromAxiosResponse from "utils/parseFileNameFromAxiosResponse";
import ReportsViewModel from "./reportsViewModel";

const navigationName = "expenses";

export default class ExpensesReportsViewModel extends ReportsViewModel {
  @computed get name() {
    return this.translate("expenses");
  }

  @computed get items() {
    return this.months.filter((month, index) => index < 4);
  }

  constructor(
    protected localizationService: LocalizationService,
    protected repository: ReportRepository,
    protected monthOptionsService: MonthOptionsService
  ) {
    super(localizationService, repository, monthOptionsService);
    this.navigationName = navigationName;
  }

  @action.bound
  @watchBusy
  async onFormSubmit() {
    if (!this.selectedMonth) {
      return;
    }
    await this.onDownloadClick(this.selectedMonth);
  }

  @action.bound
  @watchBusy
  async onDownloadClick(month: Month) {
    const defaultFileName = `report_naklady_${month.name}.xlsx`;
    try {
      const response = await this.repository.monthlyExpenses(month);
      download(response.data, parseFileNameFromAxiosResponse(response, defaultFileName));
    } catch (e) {
      console.error(e);
    }
  }
}
